import axios from "axios";
import {PlacementTagInfo} from "../model/PlacementTagInfo";

const adTagName = "Ad"
const companionTagName = "Companion"
const idAttributeName = "id"
const ivcSearchParamKey = "ivc"
const cbPlaceholder = "cb=[timestamp]"

export class RtrTagHandler {

    async fetchRtrTagXml(tag: string): Promise<any> {
        return axios.get(decodeURIComponent(tag).replace(cbPlaceholder, `cb=${Date.now()}`))
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    throw response
                }
            }).catch(err => {
                alert(`Failed fetching rtr tag [${err}]`)
                return ""
            })
    }

    extractPlacementInfoFromRtrXml(xmlString: string): PlacementTagInfo {
        const xmlDoc = (new DOMParser()).parseFromString(xmlString, "text/xml")
        const placementHash =  xmlDoc.getElementsByTagName(adTagName)[0]?.getAttribute(idAttributeName) ?? ""
        const placementUrl = new URL(xmlDoc.getElementsByTagName(companionTagName)[0]?.children[0]?.textContent ?? "http://www")
        const ivcSearchParam = placementUrl.search.replace(/\?/, "").split("&")
            .find(searchParam => searchParam.startsWith(ivcSearchParamKey)) ?? ""
        return {
            hash: placementHash,
            ivcQueryParams: decodeURIComponent(ivcSearchParam.split("=")[1] ?? "")
        }
    }
}